import { useDispatch, useSelector } from "react-redux";
import { toggleBurgerStatement } from "../../../redux/viewReducer/viewActions";

import styles from "./Burger.module.css";

function Burger() {
  const dispatch = useDispatch();
  const { burgerState } = useSelector((state) => state.viewReducer);

  const switchBurgerState = () => {
    dispatch(toggleBurgerStatement());
  };

  return (
    <div className={styles["burger-container"]}>
      <input
        type="checkbox"
        id="burger-checkbox"
        className={styles["burger-checkbox"]}
        checked={burgerState}
        onChange={switchBurgerState}
      />
      <label htmlFor="burger-checkbox" className={styles['burger']}></label>
    </div>
  );
}

export default Burger;
